import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import moment from "moment";
import "moment/locale/es"; // without this line it didn't work

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { Grid } from "@material-ui/core";
import { empresasAfiliadoStartUpdate } from "../../actions/empresasAfiliado";
import { empresasPreafiliadoStartUpdate } from "../../actions/empresasPreafiliado";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export const EmpresaModificarModal = ({ abrirModal, setAbrirModal, from, empresaAfiliado, setEmpresaAfiliado }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    setAbrirModal(abrirModal);
  }, [abrirModal, setAbrirModal]);

  const handleClose = (e) => {
    e.preventDefault();
    setAbrirModal(false);
  };

  const handleModif = (e) => {
    e.preventDefault();
    if (empresaAfiliado) {
      setAbrirModal(false);
      if (from === "AFILIACIONES") {
        dispatch(empresasAfiliadoStartUpdate(empresaAfiliado));
      } else if (from === "PREAFILIACIONES") {
        dispatch(empresasPreafiliadoStartUpdate(empresaAfiliado));
      }
    }
  };

  const handleDateFechaHastaChange = (date) => {
    setEmpresaAfiliado({
      ...empresaAfiliado,
      fechaHasta: date,
    });
  };

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="titulo"
        open={abrirModal}
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle id="tituloModal" onClose={handleClose}>
          Nueva Fecha Hasta
        </DialogTitle>
        <DialogContent dividers>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <Grid container>
              <Grid item xs={4} />
              <Grid item xs={4}>
                <KeyboardDatePicker
                  id="dialogFechaDesde"
                  label="Fec. Hasta."
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  required={true}
                  style={{ marginRight: 10 }}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  //maxDate={new Date()}  //maxDate
                  value={
                    !!empresaAfiliado.fechaHasta &&
                    moment(empresaAfiliado.fechaHasta).isValid()
                      ? moment(empresaAfiliado.fechaHasta)
                      : null
                  }
                  onChange={(date) => {
                    handleDateFechaHastaChange(date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>
              <Grid item xs={4} />
            </Grid>
          </MuiPickersUtilsProvider>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleModif} color="primary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
